import { Injectable } from '@angular/core';
import { AResourceService } from './a-resource.service';
import { CategoryModel } from '../../models/resources/category.model';
import { LanguageService } from './language.service';
import { UrlParamModel } from '../../models/url-param.model';

@Injectable({
  providedIn: 'root',
})
export class CategoryService extends AResourceService<CategoryModel> {
  constructor(private languageService: LanguageService) {
    super('/categories', false);
  }

  protected override getDefaultListParams(): UrlParamModel[] {
    const code = this.languageService.activeLanguage()?.code;
    if (!code) {
      return [];
    }
    return [{ key: 'lang', value: code }];
  }
}
